import { render } from "./HospitalsAdd.vue?vue&type=template&id=21f7d9ce&scoped=true"
import script from "./HospitalsAdd.vue?vue&type=script&lang=js"
export * from "./HospitalsAdd.vue?vue&type=script&lang=js"

import "./HospitalsAdd.vue?vue&type=style&index=0&id=21f7d9ce&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21f7d9ce"]])

export default __exports__